import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { GeneralConfigType, InteractionType, KeyValues3, KeyValueSet, LocalService, PageKey, RelationShipRole, Status } from 'src/service/local.service';

@Component({
  selector: 'app-manage-service',
  templateUrl: './manage-service.component.html',
  styleUrls: ['./manage-service.component.scss']
})
export class ManageServiceComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["addtional_service"];
  ctryCode: string = ''; userId: string = ''; interactionType: InteractionType; businessId: string = '';
  serviceTypes: KeyValueSet[]; serviceStatuses: KeyValueSet[]; items: KeyValues3[];
  RelationShipRole = RelationShipRole;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.businessId = routeParams.businessId;
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.configurationManagementService.ensurePageActions(PageKey.ManageBusinessService, this.businessId);
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.onInitiate();
        this.onLoad();
      }
    });
  }

  onInitiate() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.AdditionalServiceType, true, false).subscribe(result => {
        this.serviceTypes = result;
      });
      this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.AdditionalServiceStatus, true, false).subscribe(result => {
        this.serviceStatuses = result;
      });
    }
  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.configurationManagementService.getAdditionalServiceDetails(this.businessId).subscribe(result => {
        this.items = result;
      });
    }
  }

  getServiceStatus(key, date = '') {
    let item = this.serviceStatuses.find(x => x.key == key);
    return item ? item.value.replace('#Date#', date ?? '').replace('#Date#', date ?? '') : '-';
  }

  onAction(index, type) {
    switch (index) {
      case 1: {
        this.configurationManagementService.activateAdditionalService(this.businessId, parseInt(type), true).subscribe(result => {
          if (result.status == Status.Custom) {
            this.localService.showMessage(this.localService.languageContent.addtional_service[result.id] + ' ' + this.ctryCode + '_' + this.businessId);
          } else {
            this.onLoad();
          }
        });
      } break;
      case 2: {
        this.configurationManagementService.activateAdditionalService(this.businessId, parseInt(type), false).subscribe(result => {
          this.onLoad();
        });
      } break;
    }
  }
}
